import { useMergeState } from '@/shared/lib/customHooks';

/**
 * Backs the studies-list common questions drawer with its scrolled flag. Exposes the scroll handler that keeps isScroll in sync with the drawer body's scrollTop.
 *
 * @returns The drawer state and its scroll handler.
 */
export const useCommonQuestionsDrawer = () => {
  const [state, setState] = useMergeState({
    isScroll: false,
  });

  /**
   * Tracks whether the studies-list common questions drawer is scrolled away from the top. Reads scrollTop off the scroll event's target and updates isScroll only when it differs from the stored flag.
   *
   * @param e - Scroll event carrying the scrolled element as its target.
   * @returns Nothing.
   */
  const handleScroll = (e: any) => {
    const { scrollTop } = e.target;
    if (scrollTop === 0 && state.isScroll) {
      setState({ isScroll: false });
    } else if (scrollTop !== 0 && !state.isScroll) {
      setState({ isScroll: true });
    }
  };

  return { state, handleScroll };
};
